module.exports = __webpack_public_path__ + "img/logo.1e33b5b1.png";